import { styled, Theme } from '@mui/material/styles'

import {
  borderRadius,
  drawerMiniWidth,
  drawerWidth,
  headerHeight,
  miniDrawerBreakpoint,
  transitionDuration,
} from '../store/constant'

interface MainContentProps {
  drawerOpen: boolean
}

function openedMixin(theme: Theme): Record<string, unknown> {
  return {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter + transitionDuration,
    }),
    marginLeft: 0,
  }
}

function closedMixin(theme: Theme): Record<string, unknown> {
  const smBreakpoint = theme.breakpoints.up(miniDrawerBreakpoint)
  const drawerOffset = -(drawerWidth - drawerMiniWidth)

  return {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter + transitionDuration,
    }),
    [smBreakpoint]: {
      marginLeft: drawerOffset,
    },
  }
}

function getStyles({
  theme,
  drawerOpen,
}: {
  theme: Theme
  drawerOpen: boolean
}) {
  return {
    backgroundColor: theme.palette.grey[100],
    width: `calc(100% - ${drawerWidth}px)`,
    minHeight: `calc(100vh - ${headerHeight}px)`,
    marginTop: headerHeight,
    flexGrow: 1,
    borderRadius: `${borderRadius}px`,
    marginBottom: '16px',
    ...(drawerOpen ? openedMixin(theme) : closedMixin(theme)),
  }
}

const MainContent = styled('main', {
  shouldForwardProp: (prop: string) => (prop === 'drawerOpen' ? false : true),
})<MainContentProps>(getStyles)

export default MainContent
